import { Button } from "@/components/ui";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

interface InviteSuccessProps {
  orgName: string;
}

export function InviteSuccess({ orgName }: InviteSuccessProps) {
  const { t } = useTranslation();

  return (
    <main role="main">
      <h2 className="mb-3 text-2xl font-medium text-foreground">
        {t("acceptInvitation.success.title")}
      </h2>
      <div className="flex flex-col gap-4">
        <p>{t("acceptInvitation.success.allSet", { organization: orgName })}</p>
        <p>
          <Trans i18nKey="acceptInvitation.success.clickHere">
            <NavLink to="/" className="text-blue-primary underline">
              Click here
            </NavLink>
            to log in to ZeeMee Insights and get started.
          </Trans>
        </p>
        <div className="flex flex-col items-center gap-6 rounded-xl border p-6">
          <p>{t("acceptInvitation.success.download")}</p>
          <img src="/images/DownloadQRCode.png" className="size-28" />
          <Button asChild>
            <a href="https://zeemee.app.link/get-zeemee">
              {t("acceptInvitation.success.downloadApp")}
            </a>
          </Button>
        </div>
      </div>
    </main>
  );
}
